import axiosInstance from './axiosConfig';

const isImapMail = (mail) => Boolean(mail && (mail.source === 'imap' || mail.uid));

export function reportSpamRequest(mail) {
  if (isImapMail(mail)) {
    const uid = mail.uid ?? mail.imapUid;
    if (!uid) return Promise.reject(new Error('Missing message id'));
    return axiosInstance.patch(`/api/mail/server/spam/${encodeURIComponent(uid)}`);
  }
  const id = mail?._id || mail?.id;
  if (!id) return Promise.reject(new Error('Missing message id'));
  return axiosInstance.patch(`/api/mail/move-to-spam/${id}`);
}

export function notSpamRequest(mail) {
  if (isImapMail(mail)) {
    const uid = mail.uid ?? mail.imapUid;
    if (!uid) return Promise.reject(new Error('Missing message id'));
    return axiosInstance.patch(`/api/mail/server/not-spam/${encodeURIComponent(uid)}`);
  }
  const id = mail?._id || mail?.id;
  if (!id) return Promise.reject(new Error('Missing message id'));
  return axiosInstance.patch(`/api/mail/not-spam/${id}`);
}

export async function runMailMoves(mails, request) {
  const outcomes = await Promise.allSettled((mails || []).map((mail) => request(mail)));
  return {
    moved: mails.filter((_, index) => outcomes[index].status === 'fulfilled'),
    failed: outcomes.filter((outcome) => outcome.status === 'rejected'),
  };
}

export function moveErrorMessage(failed, fallback) {
  const reason = failed[0]?.reason;
  return reason?.response?.data?.message || reason?.message || fallback;
}
